import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ConfirmDialogData } from './confirm-dialog-data';

@Component({
	selector: 'app-confirm-dialog',
	templateUrl: './confirm-dialog.component.html',
	styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {

	constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData) { }

	/**
	 * Nein Button. Modaler Dialog wird nicht geschlossen.
	 */
	public onNoClick(): void {
		this.dialogRef.close(false);
	}

	/**
	 * Ja Button. Modaler Dialog wird geschlossen.
	 */
	public onYesClick(): void {
		this.dialogRef.close(true);
	}

}
